import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help-quickreference',
  imports: [CommonModule],
  templateUrl: './help-quickreference.component.html',
  styleUrl: './help-quickreference.component.scss'
})
export class HelpQuickreferenceComponent implements OnInit{
  selectedSection = 'quickreference';
  quickReferenceExpanded = true;

  constructor(
    private navigationService: HelpNavigationService) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.next('quickreference');

    this.navigationService.selectedSection.subscribe(section => {

      this.selectedSection = section;

      setTimeout(() => {

        const element =
          document.getElementById(section);

        const container =
          document.querySelector('.help-content') as HTMLElement;

        if (element && container) {

          container.scrollTo({
            top: element.offsetTop - 40,
            behavior: 'smooth'
          });

        }

      }, 50);

    });

  }

  changeSection(section: string): void {

    this.selectedSection = section;

    this.navigationService.selectedSection.next(section);

    setTimeout(() => {

      const element =
        document.getElementById(section);

      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 50);

  }
  toggleMenu(): void {
    this.quickReferenceExpanded =
      !this.quickReferenceExpanded;
  }
}
